module.exports = __webpack_public_path__ + "static/media/normal.535f6fc2.png";